import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { theme } from './theme';
import { AuthProvider, useAuth } from './context/AuthContext';
import ErrorBoundary from './components/ErrorBoundary';
import Home from './pages/Home';
import AdminPanel from './pages/AdminPanel';
import Login from './pages/Login';
import PageView from './pages/PageView';
import SchedulePage from './pages/SchedulePage';
import ParentsPage from './pages/ParentsPage';
import DocumentsPage from './pages/DocumentsPage';
import ConsultationsPage from './pages/ConsultationsPage';
import ConsultationsListPage from './pages/ConsultationsListPage';
import EventsPage from './pages/EventsPage';
import SpecialistsPage from './pages/SpecialistsPage';
import RequestPage from './pages/RequestPage';
import ResourcesPage from './pages/ResourcesPage';
import UsefulResourcesPage from './pages/UsefulResourcesPage';
import NewsPage from './pages/NewsPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ErrorBoundary>
        <AuthProvider>
          <Router>
            <Routes>
              <Route path="/" element={<ErrorBoundary><Home /></ErrorBoundary>} />
              <Route path="/schedule" element={<ErrorBoundary><SchedulePage /></ErrorBoundary>} />
              <Route path="/documents" element={<ErrorBoundary><DocumentsPage /></ErrorBoundary>} />
              <Route path="/consultations" element={<ErrorBoundary><ConsultationsPage /></ErrorBoundary>} />
              <Route path="/consultations-list" element={<ErrorBoundary><ConsultationsListPage /></ErrorBoundary>} />
              <Route path="/events" element={<ErrorBoundary><EventsPage /></ErrorBoundary>} />
              <Route path="/specialists" element={<ErrorBoundary><SpecialistsPage /></ErrorBoundary>} />
              <Route path="/request" element={<ErrorBoundary><RequestPage /></ErrorBoundary>} />
              <Route path="/resources" element={<ErrorBoundary><ResourcesPage /></ErrorBoundary>} />
              <Route path="/useful-resources" element={<ErrorBoundary><UsefulResourcesPage /></ErrorBoundary>} />
              <Route path="/news" element={<ErrorBoundary><NewsPage /></ErrorBoundary>} />
              <Route path="/privacy-policy" element={<ErrorBoundary><PrivacyPolicyPage /></ErrorBoundary>} />
              <Route path="/page/:slug" element={<ErrorBoundary><PageView /></ErrorBoundary>} />
              <Route path="/login" element={<ErrorBoundary><Login /></ErrorBoundary>} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <ErrorBoundary>
                      <AdminPanel />
                    </ErrorBoundary>
                  </ProtectedRoute>
                }
              />
            </Routes>
          </Router>
        </AuthProvider>
      </ErrorBoundary>
    </ThemeProvider>
  );
}

export default App;
